// let baseUrl = 'http://localhost:8080/'; 
let baseUrl = 'http://www.aitech-cms.com/';

export {
	baseUrl,
}